import { Injectable } from '@angular/core';
import { PasswordComplexityDto } from '../service-proxies/service-proxies';

@Injectable({ providedIn: 'root' })
export class SettingsService {
    private _passwordComplexity: PasswordComplexityDto;
    private _sessionTime: number;

    get passwordComplexity(): PasswordComplexityDto {
        return this._passwordComplexity;
    }

    get sessionTime(): number {
        return this._sessionTime;
    }

    set passwordComplexity(passwordComplexity: PasswordComplexityDto) {
        this._passwordComplexity = passwordComplexity;
    }

    set sessionTime(sessionTime: number) {
        this._sessionTime = sessionTime;
    }
}
